import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type PriceUpdateParams = {
	value: string;
};
export class PriceUpdate extends BaseEvent {
	constructor({ value }: PriceUpdateParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Callback,
				eventName: 'configurator - update price',
			},
			attributes: {
				componentName: 'configurator',
				value,
			},
		});
	}
}
